import { cn } from '@/lib/utils';
import React from 'react';

const InputCheck = ({ id, labelText, labelClassName, inputClassName, iconClassName, groupClassName, ...props }) => {
    return (
        <label htmlFor={id} className={cn('db-field-checkbox', groupClassName)}>
            <div className={cn('custom-checkbox', inputClassName)}>
                <input {...props} id={id} type="checkbox" className="custom-checkbox-field" />
                <i className={cn('fa-solid fa-check custom-checkbox-icon leading-[9px] text-[9px] rounded-[3px] before:leading-normal', iconClassName)}></i>
            </div>
            {labelText && <span className={cn('db-field-label', labelClassName)}>{labelText}</span>}
        </label>
    );
};

export default InputCheck;
